<template>
  <div class="agreement-doc-container">
    <!-- 顶部导航栏 -->
    <div class="agreement-doc-header">
      <h1 class="agreement-doc-title">利群数字资源平台第三方注册协议</h1>
      <div class="agreement-doc-version">版本：V1.0 | 更新时间：2024-05-20</div>
    </div>
    <!-- 注册协议内容区域（滚动显示） -->
    <div class="agreement-doc-content">
      <p class="agreement-doc-intro">本协议由第三方注册用户（以下简称“用户”）与利群集团股份有限公司（以下简称“平台方”）就用户注册及使用利群数字资源平台（以下简称“平台”）发布文章服务所订立，具有法律效力。用户注册并使用平台服务，即视为同意本协议全部内容。</p>

      <h3>1 注册条件</h3>
      <p>1.1 用户可为自然人、法人或其他组织。</p>
      <p>1.2 用户注册时需填写账号名、设置密码，确保账号名合规且密码安全即可完成注册。</p>

      <h3>2 账号管理</h3>
      <p>2.1 用户注册成功后获得平台账号，账号及密码由用户自行保管，用户对账号下所有操作承担全部责任。</p>
      <p>2.2 账号仅限用户本人使用，不得转借、出租、出售或转让，如发现账号异常使用，应立即联系企业客服。</p>

      <h3>3 服务内容与规范</h3>
      <p>3.1 平台为用户提供文章发布服务，用户发布的文章须符合国家法律法规及平台内容规范，不得包含违法、低俗、侵权、虚假等内容。</p>
      <p>3.2 平台将对用户发布的文章进行后台审核，审核通过后方可发布；对不符合规范的文章可拒绝发布、删除或要求修改；文章因不符合平台规范被拒绝发布的，平台将全额退还该篇文章的发布费用。</p>
      <p>3.3 用户保证对发布的文章拥有完整的知识产权或合法授权，不得侵犯任何第三方的著作权、肖像权、名誉权等合法权益，如引发纠纷，由用户自行承担全部责任，与平台方无关。</p>

      <h3>4 协议终止</h3>
      <p>4.1 用户违反本协议约定的，平台方有权暂停或终止提供服务，注销用户账号，且不承担赔偿责任。</p>
      <p>4.2 用户可联系企业客服申请注销账号，注销后账号相关信息将按隐私条款处理。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AgreementRegister",
  mounted() {
    // 滚动到页面顶部
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped>
.agreement-doc-container {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
  box-sizing: border-box;
}
.agreement-doc-header {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}
.agreement-doc-title {
  font-size: 20px;
  color: #333;
  text-align: center;
  margin: 10px 0;
  font-weight: 600;
}
.agreement-doc-version {
  font-size: 12px;
  color: #999;
  text-align: center;
}
.agreement-doc-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  line-height: 1.8;
  color: #333;
  font-size: 14px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
.agreement-doc-intro {
  text-indent: 0 !important;
  margin-bottom: 20px;
  color: #444;
}
.agreement-doc-content h3 {
  font-size: 16px;
  color: #222;
  margin: 20px 0 10px;
  font-weight: 600;
}
.agreement-doc-content p {
  margin: 8px 0;
  text-indent: 2em;
}
/* 滚动条样式优化 */
.agreement-doc-content::-webkit-scrollbar {
  width: 6px;
}
.agreement-doc-content::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
/* 移动端适配 */
@media screen and (max-width: 768px) {
  .agreement-doc-content {
    padding: 20px;
    max-height: calc(100vh - 180px);
  }
  .agreement-doc-title {
    font-size: 18px;
  }
}
</style>